import $ from 'jquery';

$(document).ready(function () {
  $('.paragraph-content a').each(function () {
    $(this).attr("target", "_blank");
    $(this).attr("rel", "noopener noreferrer");
  });
});